// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b976134b","455":"04fc4339"}[chunkId] + ".chunk.js";
};